import React from 'react';
import { Shield, Lock, Eye, FileCheck, Download, ExternalLink } from 'lucide-react';
import './TrustCenter.css';

const TrustCenter = () => {
    const trustPillars = [
        {
            icon: <Shield size={40} />,
            title: 'Security',
            description: 'Enterprise-grade security measures protect your data at every level. We employ industry-leading encryption, access controls, and monitoring systems.'
        },
        {
            icon: <Lock size={40} />,
            title: 'Privacy',
            description: 'Your data privacy is paramount. We adhere to strict data handling policies and never share your information without explicit consent.'
        },
        {
            icon: <Eye size={40} />,
            title: 'Transparency',
            description: 'We believe in complete transparency about how we handle data, our security practices, and our commitment to your trust.'
        },
        {
            icon: <FileCheck size={40} />,
            title: 'Compliance',
            description: 'Partsol maintains compliance with industry standards and regulations, ensuring your data is handled according to best practices.'
        }
    ];

    const documents = [
        {
            title: 'Data Protection Policy',
            description: 'Outlines Partsol\'s approach to handling and safeguarding personal data.',
            type: 'PDF',
            url: 'https://partsol.com/wp-content/uploads/2025/05/P.03-Data-Protection-Policy-2025.pdf'
        },
        {
            title: 'Cybersecurity Policy',
            description: 'Guidelines and procedures used to protect digital assets from cyber threats.',
            type: 'PDF',
            url: 'https://partsol.com/wp-content/uploads/2025/05/P.00-Partsol-Cybersecurity-Policy-2025.pdf'
        },
        {
            title: 'Privacy Policy',
            description: 'Covers what information is collected, how it is safeguarded, and how to request data.',
            type: 'Page',
            url: '/privacy-policy'
        },
        {
            title: 'Organizational & Technical Controls',
            description: 'Comprehensive guide to operational and technical controls including security management, identity access, and risk management.',
            type: 'Page',
            url: '/trust-center/controls'
        }
    ];

    return (
        <div className="trust-center-page">
            <section className="trust-hero">
                <div className="trust-hero-content">
                    <p className="trust-hero-label">Trust Center</p>
                    <h1 className="trust-hero-title">Your Trust is Our Priority</h1>
                    <p className="trust-hero-subtitle">
                        At Partsol, we are committed to maintaining the highest standards of security,
                        privacy, and transparency. Learn about our practices and how we protect your data.
                    </p>
                </div>
            </section>

            <section className="trust-pillars">
                <div className="pillars-container">
                    <p className="pillars-label">Our Commitment</p>
                    <h2 className="pillars-title">Built on Trust</h2>
                    <div className="pillars-grid">
                        {trustPillars.map((pillar, index) => (
                            <div key={index} className="pillar-card">
                                <div className="pillar-icon">{pillar.icon}</div>
                                <h3>{pillar.title}</h3>
                                <p>{pillar.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="trust-documents">
                <div className="documents-container">
                    <p className="documents-label">Resources</p>
                    <h2 className="documents-title">Featured Documents</h2>
                    <div className="documents-grid">
                        {documents.map((doc, index) => (
                            <a
                                key={index}
                                href={doc.url}
                                target={doc.type === 'PDF' ? '_blank' : '_self'}
                                rel={doc.type === 'PDF' ? 'noopener noreferrer' : undefined}
                                className="document-card"
                            >
                                <div className="document-icon">
                                    {doc.type === 'PDF' ? <Download size={24} /> : <ExternalLink size={24} />}
                                </div>
                                <div className="document-info">
                                    <h3>{doc.title}</h3>
                                    <p>{doc.description}</p>
                                    <span className="document-type">
                                        {doc.type === 'PDF' ? 'Download PDF' : 'View Page'}
                                    </span>
                                </div>
                            </a>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default TrustCenter;
